export const SLUG = {
  category: "danh-muc",
  news: "kinh-nghiem-hay",
  promotions: "khuyen-mai",
  notFound: "khong-tim-thay-trang",
};

export default {};
